import { Autocomplete, Box, Button, Dialog, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { COLORS } from "../settings/themeSettings";


const styles = {
    container: {
        // border: '1px solid blue',
        minHeight: '1000px',
        width: '1000px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: COLORS.gray[100],
        padding: '15px',
        borderRadius: '5px',
        height: 'fit-content'

    },
    pathtitle: {
        fontSize: '1em',
        fontWeight: 'bold',
        padding: '0 10px',
        width: '100%',
        color: COLORS.tertiary
    },
    path: {
        width: '300px',
        height: '100%',
        //  border: '1px solid red'
    }
}



function AjoutFraisDialog(props) {
    const { onClose, open, initialData, isEditMode } = props;

    const [montantCFA, setMontantCFA] = useState('');
    const [quantite, setQuantite] = useState(1);
    const [currency, setCurrency] = useState('CFA');
    const [designation, setDesignation] = useState('');

    // Payment fields
    const [includePayment, setIncludePayment] = useState(true);
    const paymentMethods = ['compte', 'Chéque', 'CASH', 'carte de crédit', 'Autre'];
    const [modePaiement, setModePaiement] = useState(paymentMethods[2]); // CASH by default
    const [paymentDate, setPaymentDate] = useState(dayjs().format('YYYY-MM-DD'));
    const [paymentCommentaire, setPaymentCommentaire] = useState('');

    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick")
            return;
        onClose();
    };

    useEffect(() => {
        if (open) {
            if (initialData && isEditMode) {
                setMontantCFA(initialData.prixUnitaire || '');
                setQuantite(initialData.quantite || 1);
                setCurrency(initialData.currency || 'CFA');
                setDesignation(initialData.designation || '');
                setIncludePayment(false); 
            } else {
                setMontantCFA('');
                setQuantite(1);
                setCurrency('CFA');
                setDesignation('');
                setIncludePayment(true);
                setModePaiement(paymentMethods[2]);
                setPaymentDate(dayjs().format('YYYY-MM-DD'));
                setPaymentCommentaire('');
            }
        }
    }, [open, initialData, isEditMode]);


    const addBill = () => {
        const totalAmountCFA = currency === 'EURO' 
            ? parseFloat(montantCFA) * 655.957 * parseFloat(quantite)
            : parseFloat(montantCFA) * parseFloat(quantite);

        const bill = {
            prixUnitaire: montantCFA,
            designation,
            nature: designation,
            quantite,
            currency
        }

        let payment = null;
        if (includePayment) {
            payment = {
                methode: modePaiement,
                montant: totalAmountCFA,
                date: paymentDate,
                commentaire: paymentCommentaire || designation
            }
        }

        onClose({ bill, payment });
    }


    return (
        <Dialog onClose={handleClose} open={open} maxWidth={'lg'} PaperProps={{ sx: { minWidth: '700px' } }} >
            <DialogTitle
                sx={{
                    backgroundColor: COLORS.secondary,
                    color: 'white',
                    mb: 4
                }}
            >{isEditMode ? "Modifier la prestation" : "Ajouter une prestation et règlement"}</DialogTitle>


            <Stack
                direction="row"
                spacing={4}
                sx={{
                    padding: '20px',
                    minWidth: '800px'
                }}
            >
                {/* Section Prestation */}
                <Box sx={{ flex: 1 }}>
                    <Typography variant="h6" sx={{ color: COLORS.secondary, mb: 2, fontWeight: 'bold', borderBottom: `2px solid ${COLORS.secondary}` }}>
                        Prestation
                    </Typography>
               
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        size="small"
                        color="secondary"
                        focused
                        label="Prestation"
                        placeholder='Nom de la prestation'
                        value={designation}
                        onChange={(e) => { setDesignation(e.target.value) }}
                    />
                    

                    <Stack direction="row" spacing={2}>
                        <TextField
                            type="number"
                            margin="normal"
                            required
                            fullWidth
                            size="small"
                            label="Prix unitaire"
                            color="secondary"
                            focused
                            value={montantCFA}
                            onChange={(e) => setMontantCFA(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            type="number"
                            required
                            fullWidth
                            size="small"
                            color="secondary"
                            focused
                            label="Quantité"
                            value={quantite}
                            onChange={(e) => { setQuantite(e.target.value) }}
                        />
                    </Stack>

                    <Box sx={{ mt: 2, display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold', color: COLORS.tertiary }}>Devise :</Typography>
                        <Button
                            size="small"
                            variant={currency === 'CFA' ? 'contained' : 'outlined'}
                            onClick={() => setCurrency('CFA')}
                            color="secondary"
                        >CFA</Button>
                        <Button
                            size="small"
                            variant={currency === 'EURO' ? 'contained' : 'outlined'}
                            onClick={() => setCurrency('EURO')}
                            color="secondary"
                        >EURO</Button>
                    </Box>
                </Box>

                {/* Section Paiement */}
                {!isEditMode && (
                    <Box sx={{ flex: 1, pl: 4, borderLeft: `1px solid ${COLORS.gray[300]}` }}>
                        <Typography variant="h6" sx={{ color: COLORS.tertiary, mb: 2, fontWeight: 'bold', borderBottom: `2px solid ${COLORS.tertiary}` }}>
                            Règlement Associé
                        </Typography>
               
                        <Stack spacing={2}>
                            <Autocomplete
                                size="small"
                                value={modePaiement}
                                onChange={(event, newValue) => setModePaiement(newValue)}
                                options={paymentMethods}
                                color="secondary"
                                renderInput={(params) => <TextField {...params} label="Mode de paiement" />}
                            />

                            <TextField
                                label="Montant à régler (CFA)"
                                size="small"
                                disabled
                                value={currency === 'EURO' 
                                    ? (parseFloat(montantCFA) * 655.957 * parseFloat(quantite) || 0).toFixed(0)
                                    : (parseFloat(montantCFA) * parseFloat(quantite) || 0).toFixed(0)
                                }
                                color="secondary"
                                focused
                            />

                            <TextField
                                type="date"
                                label="Date règlement"
                                size="small"
                                fullWidth
                                value={paymentDate}
                                onChange={(e) => setPaymentDate(e.target.value)}
                                color="secondary"
                                focused
                                InputLabelProps={{ shrink: true }}
                            />

                            <TextField
                                label="Commentaire règlement"
                                size="small"
                                fullWidth
                                multiline
                                rows={2}
                                value={paymentCommentaire}
                                onChange={(e) => setPaymentCommentaire(e.target.value)}
                                color="secondary"
                                focused
                                placeholder="Laisser vide pour utiliser le motif"
                            />
                        </Stack>
                    </Box>
                )}
            </Stack>
            
            <Stack direction="row" justifyContent="center" spacing={2} sx={{ mb: 4, mt: 2 }}>
                <Button variant="outlined" color="error" onClick={handleClose}>Annuler</Button>
                <Button variant="contained" color="secondary" onClick={addBill}>{isEditMode ? "Enregistrer" : "Valider"}</Button>
            </Stack>

        </Dialog>
    );
}

export default AjoutFraisDialog;
